import documentosAPI, { DocumentoRequestUpdate, DocumentoRequestUpload, DocumentoResponse, documentoServiceDownload } from 'api/Assessor/documentos';
import duvidasAPI, { ListaPerguntaResponse } from 'api/Assessor/duvidas';
import eventoAPI from 'api/Assessor/evento';
import { ErrorAPI } from 'api/Assessor/methods';
import { AxiosError, AxiosResponse } from 'axios';
import { AssembleiaPautaStatus } from 'enuns/AssembleiaPautaStatus';
import { AssembleiaStatus } from 'enuns/AssembleiaStatus';
import AlteraUrlTransmissaoAssembleia from 'models/AlteraUrlTransmissaoAssembleia';
import { AssembleiaContaAssessor } from 'models/AssembleiaContaAssessor';
import AssembleiaProduto from 'models/AssembleiaProduto';
import AssembleiaProdutosPorTipo from 'models/AssembleiaProdutosPorTipo';
import AssembleiaProdutoTipo from 'models/AssembleiaProdutoTipo';
import AssembleiaTipo from 'models/AssembleiaTipo';
import CadastroAssembleia from 'models/CadastroAssembleia';
import { ListaEventoRequest } from 'models/ListaEventoRequest';
import { ListaEventoResponse } from 'models/ListaEventoResponse';
import PresencasResponse from 'models/PresencasResponse';
import RetornoCadastroAssembleia from 'models/RetornoCadastroAssembleia';
import RetornoTipoDocumento from 'models/RetornoTipoDocumento';
import TipoDocumento from 'models/TipoDocumento';
import TipoDocumentoRequest from 'models/TipoDocumentoRequest';
import TotalizadoresConvocadosResponse from 'models/TotalizadoresConvocadosResponse';
import moment from 'moment';
import { Action, Dispatch } from "redux";
import { ThunkAction } from 'redux-thunk';
import { IReducer } from 'store/Reducer';
import { getPautaAssessorWithOrderedOptions } from 'utils/AssembleiaUtils';
import trigger from 'utils/DownloadTrigger';
import { getAssembleiasAssessorEndpoint } from "../../library/Apis";
import ApiService from "../../services/ApiService";
import { toRequest } from "../../utils/RequestUtils";
import { AssembleiasAssessorActionTypes, ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA, ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT, ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS, ASSEMBLEIAS_ASSESSOR_ACTIONS_LIBERAR_PAUTA, ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE, ASSEMBLEIAS_ASSESSOR_ACTIONS_RESULTADO_VOTO_PAUTA, ASSEMBLEIAS_ASSESSOR_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA, ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA, ASSEMBLEIAS_ASSESSOR_ALTERA_URL_TRANSMISSAO, ASSEMBLEIAS_ASSESSOR_ATUALIZANDO_CONVOCADOS, ASSEMBLEIAS_ASSESSOR_ATUALIZAR_CONVOCADOS, ASSEMBLEIAS_ASSESSOR_BLOQUEANDO_CONVOCACOES, ASSEMBLEIAS_ASSESSOR_BLOQUEAR_CONVOCACOES, ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA, ASSEMBLEIAS_ASSESSOR_CADASTRAR, ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA, ASSEMBLEIAS_ASSESSOR_DELETANDO_TIPO_DOCUMENTO, ASSEMBLEIAS_ASSESSOR_DELETAR, ASSEMBLEIAS_ASSESSOR_EDITAR, ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA, ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS, ASSEMBLEIAS_ASSESSOR_LOADING_DOCUMENTOS, ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS, ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO, ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO, ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_PAGINADA_EVENTO, ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS, ASSEMBLEIAS_ASSESSOR_LOADING_PRESENCAS, ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS_POR_TIPO, ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS, ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_DOCUMENTOS, ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_PRODUTO, ASSEMBLEIAS_ASSESSOR_LOAD_AGENCIAS_PAUTA, ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS, ASSEMBLEIAS_ASSESSOR_LOAD_DOCUMENTOS, ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS, ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO, ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO, ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_PAGINADA_EVENTO, ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS, ASSEMBLEIAS_ASSESSOR_LOAD_PRESENCAS, ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS_POR_TIPO, ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS, ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_DOCUMENTOS, ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_PRODUTO, ASSEMBLEIAS_ASSESSOR_REFRESH, ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA, ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_ALTERAR, ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_CADASTRAR, IAssembleiasAssessorDeleteCurrentEvent, IAssembleiasAssessorRefresh, ASSEMBLEIAS_ASSESSOR_LOADING_TOTALIZADORES_CONVOCADOS, ASSEMBLEIAS_ASSESSOR_LOAD_TOTALIZADORES_CONVOCADOS, ASSEMBLEIAS_ASSESSOR_BUSCAR_PAUTA, ASSEMBLEIAS_ASSESSOR_ACTIONS_REGISTRA_VOTO, ASSEMBLEIAS_ASSESSOR_ACTIONS_CLEARED_CURRENT_EVENT, IAssembleiasAssessorClearedCurrentEvent, ASSEMBLEIAS_ASSESSOR_FORCE_LOAD_PAUTAS, IAssembleiaAssessorForceLoadPautas } from './AssembleiasAssessorActionTypes';
import { IAssembleiasAssessoresAlteraStatusPauta, IAssembleiasAssessoresRegistrarPresenca, IAssembleiasAssessorEvent, IAssembleiasAssessorEventList, IAssembleiasAssessorPauta, ICadastrarPautaRequest, IListaAgenciasPauta, IRequestPautasRespostas, IAssembleiaResultadosVotos } from './AssembleiasAssessorReducer';
import { IWSAssembleia } from './WSAssembleiasReducer';


type ThunkActionDefault = ThunkAction<Promise<void>, IReducer, undefined, any>;

export const assembleiaAssessorActionsRefresh = (assembleia: IWSAssembleia):IAssembleiasAssessorRefresh => {
  return {
    type: ASSEMBLEIAS_ASSESSOR_REFRESH,
    payload: assembleia
  }
}

export const assembleiaAssessorForceLoadPautas = ():IAssembleiaAssessorForceLoadPautas => {
  return {
    type: ASSEMBLEIAS_ASSESSOR_FORCE_LOAD_PAUTAS,
  }
}

export const assembleiasAssessorIncluirPergunta = (
  idEvento: number,
  pergunta: string,
  callbackSuccess?: Function,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return () => {
    toRequest(
      ApiService.post,
      [
        `${getAssembleiasAssessorEndpoint()}pergunta/registra-pergunta`,
        {
          idAssembleia: idEvento,
          pergunta
        }
      ],
      '')
      .then(
        () => {
          if (typeof callbackSuccess === 'function') {
            callbackSuccess();
          }
        },
        error => {
          if (typeof callbackError === 'function') {
            callbackError(error);
          }
        }
      )
  }
}

export const assembleiasAssessorLoadTipos = (callbackSuccess?: (tipos: AssembleiaTipo[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS,
      payload: true
    });
    new Promise((resolve: (tipos: AssembleiaTipo[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}tipo-assembleia`],
        'encerrar')
        .then(
          (resp: AxiosResponse) => {
            const tipos: AssembleiaTipo[] = resp.data as AssembleiaTipo[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS,
              payload: tipos
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS,
              payload: false
            });
            resolve(tipos);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      (tipos: AssembleiaTipo[]) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(tipos);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorIncluirTipoDocumento = (tipo: TipoDocumentoRequest, callbackSuccess?: (data: RetornoTipoDocumento) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: (data: RetornoTipoDocumento) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.post,
        [`${getAssembleiasAssessorEndpoint(1)}tipo-documento/`, tipo],
        'encerrar')
        .then(
          (resp: AxiosResponse) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_CADASTRAR,
              payload: tipo
            });
            const data = resp.data as RetornoTipoDocumento;
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      (data) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(data);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorAlterarTipoDocumento = (tipo: TipoDocumentoRequest, id:number, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: () => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.put,
        [`${getAssembleiasAssessorEndpoint(1)}tipo-documento/${id}`, tipo],
        'encerrar')
        .then(
          () => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_TIPOS_DOCUMENTOS_ALTERAR,
              payload: tipo
            });
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}


export const assembleiasAssessorTipoDocumento = (callbackSuccess?: (tipos: TipoDocumento[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_DOCUMENTOS,
      payload: true
    });
    new Promise((resolve: (tipos: TipoDocumento[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}tipo-documento/`],
        'encerrar')
        .then(
          (resp: AxiosResponse) => {
            const tipos: TipoDocumento[] = resp.data as TipoDocumento[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_DOCUMENTOS,
              payload: tipos
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_DOCUMENTOS,
              payload: false
            });
            resolve(tipos);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_DOCUMENTOS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      (tipos: TipoDocumento[]) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(tipos);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorDeletarTipoDocumento = (idTipo: number, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_DELETANDO_TIPO_DOCUMENTO,
      payload: true
    });
    new Promise((resolve: () => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.delete,
        [`${getAssembleiasAssessorEndpoint(1)}tipo-documento/${ idTipo }`],
        'deletarPauta')
        .then(
          () => {

            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_DELETANDO_TIPO_DOCUMENTO,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_DELETANDO_TIPO_DOCUMENTO,
          payload: false
        });
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorLoadTiposProduto = (callbackSuccess?: (tiposProduto: AssembleiaProdutoTipo[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_PRODUTO,
      payload: true
    });
    new Promise((resolve: (tiposProduto: AssembleiaProdutoTipo[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}tipo-produto`],
        'encerrar')
        .then(
          (resp: AxiosResponse) => {
            const tipos: AssembleiaProdutoTipo[] = resp.data as AssembleiaProdutoTipo[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_TIPOS_PRODUTO,
              payload: tipos
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_PRODUTO,
              payload: false
            });
            resolve(tipos);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_TIPOS_PRODUTO,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      (tiposProduto: AssembleiaProdutoTipo[]) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(tiposProduto);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorLoadProdutosPorTipo = (idTipoProduto: number, callbackSuccess?: (produtos: AssembleiaProdutosPorTipo) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS_POR_TIPO,
      payload: true
    });
    new Promise((resolve: (produtos: AssembleiaProdutosPorTipo) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}produto/tipo-produto/${idTipoProduto}`],
        'encerrar')
        .then(
          (resp: AxiosResponse) => {
            const produtos: AssembleiaProduto[] = resp.data as AssembleiaProduto[];
            const produtosPorTipo: AssembleiaProdutosPorTipo = {
              idTipoProduto,
              produtos
            }
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_PRODUTOS_POR_TIPO,
              payload: produtosPorTipo
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS_POR_TIPO,
              payload: false
            });
            resolve(produtosPorTipo);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PRODUTOS_POR_TIPO,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      (produtosPorTipo: AssembleiaProdutosPorTipo) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(produtosPorTipo);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorCadastrar = (assembleia: CadastroAssembleia, callbackSuccess?: (data: RetornoCadastroAssembleia) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: (data: RetornoCadastroAssembleia) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.post,
        [`${getAssembleiasAssessorEndpoint(1)}assembleia/`, assembleia],
        'encerrar')
        .then(
          (resp: AxiosResponse) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_CADASTRAR,
              payload: assembleia
            });
            const data = resp.data as RetornoCadastroAssembleia;
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      (data) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(data);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorEditar = (idAssembleia: number, assembleia: CadastroAssembleia, callbackSuccess?: (data: RetornoCadastroAssembleia) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: (data: RetornoCadastroAssembleia) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.put,
        [`${getAssembleiasAssessorEndpoint(1)}assembleia/`, {
          ...assembleia,
          idAssembleia,
        }],
        'encerrar')
        .then(
          (resp: AxiosResponse) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_EDITAR,
              payload: assembleia
            });
            const data = resp.data as RetornoCadastroAssembleia;
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      (data) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(data);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorAlteraUrlTransmissao = (data: AlteraUrlTransmissaoAssembleia, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.put,
        [`${getAssembleiasAssessorEndpoint(1)}assembleia/url`, data],
        'encerrar')
        .then(
          () => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_ALTERA_URL_TRANSMISSAO,
              payload: data
            });
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorAlteraStatusPauta = (pauta: IAssembleiasAssessoresAlteraStatusPauta, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA,
      payload: true
    });
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.put,
        [`${getAssembleiasAssessorEndpoint(1)}pauta/status`,{
          pauta: {
            idPauta: pauta.idPauta,
            minutos: pauta.minutos,
            status: pauta.status
          }
        }],
        'encerrar')
        .then(
          () => {
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA,
          payload: false
        });
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorLoadEvento = (idEvento: number, callbackSuccess?: (all: IAssembleiasAssessorEvent) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO,
      payload: true
    });
    new Promise((resolve: (all: IAssembleiasAssessorEvent) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}assembleia/${idEvento}`],
        'assembleiaAssessorLodEvent')
        .then(
          resp => {
            const data: IAssembleiasAssessorEvent = {
              ...resp.data,
              nome: resp.data.titulo,
              id: resp.data.idAssembleia || resp.data.id,
              urlTransmissao: resp.data.urlTranmissao || resp.data.urlTransmissao
            } as IAssembleiasAssessorEvent;
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      all => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(all);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  } 
};

export const assembleiasAssessorActionsLoadEventoList = (
  callbackSuccess: (response: IAssembleiasAssessorEventList[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO,
      payload: true
    });
    new Promise((resolve: (eventList: IAssembleiasAssessorEventList[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}assembleia`],
        'assembleiaAssessorLodEventList')
        .then(
          resp => {
            const data: IAssembleiasAssessorEventList[] = resp.data as IAssembleiasAssessorEventList[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      eventList => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(eventList);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorActionsAtualizarPresencas = (
  idEvento: number,
  callbackSuccess?: (data: PresencasResponse) => void,
  callbackError?: (error: ErrorAPI) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_PRESENCAS,
      payload: true
    });
    new Promise((resolve: (eventList: PresencasResponse) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}assembleia/presencas/${idEvento}`],
        '')
        .then(
          resp => {
            const data: PresencasResponse = {
              ...resp.data,
              idEvento
            } as PresencasResponse;
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_PRESENCAS,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PRESENCAS,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PRESENCAS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      eventList => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(eventList);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
};

export const assembleiasAssessorActionsLoadEventoPageList = (
  request: Partial<ListaEventoRequest>,
  callbackSuccess: (response: ListaEventoResponse) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_PAGINADA_EVENTO,
      payload: true
    });
    new Promise((resolve: (eventList: ListaEventoResponse) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.post,
        [`${getAssembleiasAssessorEndpoint(1)}assembleia/page`, {
          ...request,
          page: (request.page || 0) + 1,
          dataInicial: moment(request.dataInicial).format('YYYY-MM-DD'),
          dataFinal: moment(request.dataFinal).format('YYYY-MM-DD'),
          tipoAssembleia: request.tipo
        }],
        'assembleiaAssessorLodEventList')
        .then(
          resp => {
            const data: ListaEventoResponse = resp.data as ListaEventoResponse;
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_PAGINADA_EVENTO,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_PAGINADA_EVENTO,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_PAGINADA_EVENTO,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      eventList => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(eventList);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorActionsAlterarSituacaoPauta = (idPauta: number, tempo: number, status: AssembleiaPautaStatus, callbackSuccess?: Function, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.put,
        [
          `${getAssembleiasAssessorEndpoint(1)}pauta/status`,
          {
            idPauta,
            tempo,
            status
          }
        ],
        'save')
        .then(
          resp => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA
            });
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorActionsAlterarSituacaoPautaPorData = (idPauta: number, dataTime: string, status: AssembleiaPautaStatus, callbackSuccess?: Function, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.put,
        [
          `${getAssembleiasAssessorEndpoint(1)}pauta/enviarTempo`,
          {
            idPauta,
            dataTime,
            status
          }
        ],
        'save')
        .then(
          resp => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA
            });
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorActionsAlterarSituacaoAssembleia = (assembleiaId: number, status: AssembleiaStatus, callbackSuccess?: Function, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return () => {
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.put,
        [
          `${getAssembleiasAssessorEndpoint(1)}assembleia/status`,
          {
            idAssembleia: assembleiaId,
            status: status
          }
        ],
        'assembleiaAssessorLodPautas')
        .then(
          resp => {
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorActionsLoadPautas = (assembleiaId: number, cpfCnpj: string, callbackSuccess?: (pautas: IAssembleiasAssessorPauta[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
      payload: true
    });
    new Promise((resolve: (pautas: IAssembleiasAssessorPauta[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}pauta/byAssembleia/${assembleiaId}`],
        'assembleiaAssessorLodPautas')
        .then(
          resp => {
            const pautas: IAssembleiasAssessorPauta[] = resp.data as IAssembleiasAssessorPauta[];
            const data: IAssembleiasAssessorPauta[] = pautas.map(
              (pauta: IAssembleiasAssessorPauta): IAssembleiasAssessorPauta => {
                return getPautaAssessorWithOrderedOptions(pauta)
              }
            );
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS,
              assembleiaId,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      pautas => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(pautas);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export function assembleiasAssessorActionsDeleteCurrentEvent(): IAssembleiasAssessorDeleteCurrentEvent {
  return {
    type: ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT,
    payload: undefined
  }
};

export function assembleiasAssessorActionsClearedCurrentEvent(): IAssembleiasAssessorClearedCurrentEvent {
  return {
    type: ASSEMBLEIAS_ASSESSOR_ACTIONS_CLEARED_CURRENT_EVENT,
    payload: undefined
  }
};

export type ThunkDownloadDocumentAssessorReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  Action
>;

export function assembleiaAssessorActionsDownloadDocument(
  idDocument: number,
  fileName: string,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkDownloadDocumentAssessorReturn {
  return async (dispatch, getState) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE,
      payload: [...getState().assembleiasAssessor.downloadindDocument, idDocument],
    });
    const { fail, data: file } = await documentosAPI.download(idDocument);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (file) {
      trigger(fileName, file);
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS,
        payload: [...getState().assembleiasAssessor.downloadSuccessfully, idDocument],
      });
      successCallback && successCallback();
    }
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE,
      payload: getState().assembleiasAssessor.downloadindDocument.filter(
        id => id !== idDocument
      ),
    });
  };
}

export const assembleiasAssessorActionsLoadContas = (eventoId: number, cpfCnpj: string, callbackSuccess?: (contas: AssembleiaContaAssessor[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
      payload: true
    });
    new Promise((resolve: (contas: AssembleiaContaAssessor[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        // [`${getAssembleiasAssessorEndpoint(1)}evento/${ eventoId }/convocado/${ cpfCnpj }`],
        [`${getAssembleiasAssessorEndpoint(1)}/convocado/${ cpfCnpj }/${eventoId}/assembleia`],
        'assembleiaAssessorLaodContas')
        .then(
          resp => {
            const data: AssembleiaContaAssessor[] = resp.data as AssembleiaContaAssessor[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      contas => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(contas);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorActionsLoadContasCanalVoz = (eventoId: number, cpfCnpj: string, callbackSuccess?: (contas: AssembleiaContaAssessor[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
      payload: true
    });
    new Promise((resolve: (contas: AssembleiaContaAssessor[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        // [`${getAssembleiasAssessorEndpoint(1)}evento/${ eventoId }/convocado/${ cpfCnpj }`],
        [`${getAssembleiasAssessorEndpoint(1)}/convocado/presenca/${ cpfCnpj }/${eventoId}/assembleia`],
        'assembleiaAssessorLaodContas')
        .then(
          resp => {
            const data: AssembleiaContaAssessor[] = resp.data as AssembleiaContaAssessor[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      contas => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(contas);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export type ThunkDuvidasReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  Action
>

export const assembleiasAssessorActionsLoadDuvidas = (
  idEvento: number,
  callbackSuccess?: (duvidas: ListaPerguntaResponse) => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkDuvidasReturn => {
  return async dispatch => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS,
      payload: true
    });
    const { fail, data } = await duvidasAPI.listar(idEvento);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS,
        payload: data
      });
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS,
      payload: false
    });
  }
}

export const assembleiasAssessorRegistrarPresenca = (registrarPresencaRequest: IAssembleiasAssessoresRegistrarPresenca, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA,
      payload: true
    });
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.post,
        [`${getAssembleiasAssessorEndpoint(1)}presenca/`, registrarPresencaRequest],
        'registrarPresenca')
        .then(
          () => {
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA,
          payload: false
        });
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorLoadAgenciasPauta = (idPauta: number, callbackSuccess?: (all: IListaAgenciasPauta[]) => void, callbackError?: (error: AxiosError) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA,
      payload: true
    });
    new Promise((resolve: (all: IListaAgenciasPauta[]) => void, reject: (error: AxiosError) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}pauta/agencias-pauta/?idPauta=${ idPauta }`],
        'assembleiaAssessorLodAgenciasPauta')
        .then(
          resp => {
            const data: IListaAgenciasPauta[] = resp.data as IListaAgenciasPauta[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_AGENCIAS_PAUTA,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      all => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(all);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  } 
};

export const assembleiasAssessorActionsLiberarResultadoPauta = (idPauta: number, flgLiberado: boolean, callbackSuccess?: Function, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.post,
        [
          `${getAssembleiasAssessorEndpoint(1)}pauta/${idPauta}/resultado`,
          {
            "isLiberado": flgLiberado
          }
        ],
        'save')
        .then(
          () => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_ACTIONS_LIBERAR_PAUTA
            });
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorPautaResposta = (votoPresencialRequest: IRequestPautasRespostas, callbackSuccess?: () => void, callbackError?: (error: AxiosError) => void) => {
  return () => {
    new Promise((resolve: Function, reject: (error: AxiosError) => void) => {
      toRequest(
        ApiService.put,
        [`${getAssembleiasAssessorEndpoint(1)}pauta/respostas`,{
          codigoAgencia: votoPresencialRequest.codigoAgencia,
          idPauta: votoPresencialRequest.idPauta,
          itensPauta: votoPresencialRequest.itensPauta,
          numeroNucleo: votoPresencialRequest.numeroNucleo
        }],
        'encerrar')
        .then(
          () => {
            resolve();
          },
          (error: AxiosError) => {
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorCadastrarPauta = (pautaRequest: ICadastrarPautaRequest, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA,
      payload: true
    });
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        pautaRequest.idPauta ? ApiService.put : ApiService.post,
        [`${getAssembleiasAssessorEndpoint(1)}pauta/`, pautaRequest],
        'cadastroPauta')
        .then(
          () => {
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA,
          payload: false
        });
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorDeletarPauta = (idPauta: number, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA,
      payload: true
    });
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.delete,
        [`${getAssembleiasAssessorEndpoint(1)}pauta/${ idPauta }`],
        'deletarPauta')
        .then(
          () => {

            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA,
          payload: false
        });
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorDeletarAssembleia = (idAssembleia: number, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.delete,
        [`${getAssembleiasAssessorEndpoint(1)}assembleia/${ idAssembleia }`],
        'deletarPauta')
        .then(
          () => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_DELETAR,
              payload: idAssembleia
            });
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        )
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

type ThunkConvocacaoReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  Action
>

export const assembleiasAssessorActionsAtualizarPresencasConvocados = (
  idAssembleia: number,
  callbackSuccess?: (data: TotalizadoresConvocadosResponse) => void,
  callbackError?: (error: ErrorAPI) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_TOTALIZADORES_CONVOCADOS,
      payload: true
    });
    new Promise((resolve: (eventList: TotalizadoresConvocadosResponse) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}convocado/assembleia/${idAssembleia}/total`],
        '')
        .then(
          resp => {
            const data: TotalizadoresConvocadosResponse = {
              ...resp.data
            } as TotalizadoresConvocadosResponse;
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_TOTALIZADORES_CONVOCADOS,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_TOTALIZADORES_CONVOCADOS,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_TOTALIZADORES_CONVOCADOS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      eventList => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(eventList);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
};

export const assembleiaAssessorAtualizarConvocados = (
  idAssembleia: number,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void,
): ThunkConvocacaoReturn => {
  return async dispatch => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_ATUALIZANDO_CONVOCADOS,
      payload: true,
    });
    const { fail, response } = await eventoAPI.convocar(idAssembleia);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response && response.status === 200) {
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_ATUALIZAR_CONVOCADOS,
        payload: {
          idAssembleia,
          flgConvocado: true,
        }
      });
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_ATUALIZANDO_CONVOCADOS,
      payload: false,
    });
  };
};

export const assembleiaAssessorBloquearConvocacao = (
  idAssembleia: number,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void,
): ThunkConvocacaoReturn => {
  return async dispatch => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_BLOQUEANDO_CONVOCACOES,
      payload: true,
    });
    const { fail, response } = await eventoAPI.bloquear(idAssembleia);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response && response.status === 200) {
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_BLOQUEAR_CONVOCACOES,
        payload: {
          idAssembleia,
          flgBloqueio: true,
        }
      });
      callbackSuccess && callbackSuccess();
    }
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_BLOQUEANDO_CONVOCACOES,
      payload: false,
    });
  };
};

export function assembleiaAssessorActionsUpdateDocument(
  request: DocumentoRequestUpdate,
  idDocumento: number,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = await documentosAPI.update(request, idDocumento);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export function assembleiaAssessorActionsRemoveDocument(
  idDocumento: number,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = await documentosAPI.remove(idDocumento);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export function assembleiaAssessorActionsUploadDocument(
  data: DocumentoRequestUpload,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = await documentosAPI.upload(data.idAssembleia, data.idTipoDocumento, data.flgVisivelAssociado, data.descricao, data.arquivo);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export const documentoActionDownload = (
  codigo: string,
  callbackSuccess?: (arrayBuffer: ArrayBuffer) => void,
  callbackError?: (error: AxiosError) => void,
) => {
  return () => {
    documentoServiceDownload(codigo).then(
      (arrayBuffer: ArrayBuffer) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(arrayBuffer);
        }
      },
      (error: AxiosError) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      },
    );
  };
};


export const assembleiasAssessorListDocumentos = ( 
  idAssembleia:number,
  callbackSuccess?: (documentos: DocumentoResponse[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_DOCUMENTOS,
      payload: true
    });
    new Promise((resolve: (documentos: DocumentoResponse[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}documento/assembleia/${idAssembleia}`],
        'encerrar')
        .then(
          (resp: AxiosResponse) => {
            const documentos: DocumentoResponse[] = resp.data as DocumentoResponse[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_DOCUMENTOS,
              payload: documentos
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_DOCUMENTOS,
              payload: false
            });
            resolve(documentos);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_DOCUMENTOS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      (documentos: DocumentoResponse[]) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(documentos);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorResultadosVotos = (idPauta: number, callbackSuccess?: (resultados: IAssembleiaResultadosVotos) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA,
      payload: true
    });
    new Promise((resolve: (resultados: IAssembleiaResultadosVotos) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}pauta/${idPauta}/resultado-votos`],'')
        .then(
          (resp: AxiosResponse) => {
            const resultados: IAssembleiaResultadosVotos = resp.data as IAssembleiaResultadosVotos;
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_ACTIONS_RESULTADO_VOTO_PAUTA,
              payload: resultados
            });
            resolve(resultados);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      (resultados: IAssembleiaResultadosVotos) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resultados);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorBuscarPautaPorCpf = (idAssembleia: number, cpf: string, callbackSuccess?: (contas: IAssembleiasAssessorPauta[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
      payload: true
    });
    new Promise((resolve: (contas: IAssembleiasAssessorPauta[]) => void, reject: (error: AxiosError<ErrorAPI>) => void) => {
      toRequest(
        ApiService.get,
        [`${getAssembleiasAssessorEndpoint(1)}/voto-presencial/assembleia/${ idAssembleia }/pessoa/${cpf}/pautas`],
        '')
        .then(
          resp => {
            const data: IAssembleiasAssessorPauta[] = resp.data as IAssembleiasAssessorPauta[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_BUSCAR_PAUTA,
              idAssembleia,
              payload: data
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
              payload: false
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
              payload: false
            });
            reject(error);
          }
        )
    }).then(
      contas => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(contas);
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

export const assembleiasAssessorActionsRegistraVoto = (
  idItemPauta: number,
  cpfCnpj: string,
  callbackSuccess?: Function,
  callbackError?: (error: AxiosError) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise((resolve: Function, reject: (error: AxiosError) => void) => {
      const data = {
        idItemPauta,
        cpfCnpj
      };
      toRequest(
        ApiService.post,
        [`${getAssembleiasAssessorEndpoint(1)}voto-presencial/voto`, data],
        'save'
      ).then(
        () => {
          dispatch({
            type: ASSEMBLEIAS_ASSESSOR_ACTIONS_REGISTRA_VOTO
          })
          resolve();
        },
        (error: AxiosError) => {
          reject(error);
        }
      );
    }).then(
      pautas => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      error => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};